import { Box, styled } from '@mui/material';
import { ReactComponent as PinIcon } from 'assets/img/icons/dark-pin.svg';
import defaultPartnerImage from 'assets/img/partners/default-partner-image.png';
import Image from 'DesignSystem/DataDisplay/Image/Image';
import Icon from 'DesignSystem/Primitives/Icon/Icon';
import ThemeTypography from 'DesignSystem/Primitives/Typography/ThemeTypography';
import React, { FC } from 'react';
import { IBasePartnerCompany } from 'FeatureModules/Partner/types/partner.types';
import {
  getCompanyStatusColor,
  getReadableCompanyStatus,
} from 'FeatureModules/Partner/utils/partner.utils';
import { OpacityContainer, StyledCell, Title } from './PartnersTableBody.styles';
import FlexBox from 'Components/FlexBox';

interface IProps {
  align?: 'left' | 'right' | 'center';
  partner: IBasePartnerCompany;
  hidePartnerInvitationStatus?: boolean;
}

export const Pin = styled(PinIcon)(({ theme }) => ({
  marginRight: theme.spacing(0.5),
  width: 14,
  height: 14,
  color: theme.custom.themeColors.grayScale[100],
}));

const PartnerTableTitle: FC<IProps> = ({ align, partner, hidePartnerInvitationStatus }) => {
  const isPartnerInvitationsEnabled = !hidePartnerInvitationStatus;
  const { name: title, logo, status, externalId } = partner;

  return (
    <StyledCell scope="row" align={align}>
      <OpacityContainer display="flex" is-transparent="false" alignItems="center">
        <Image
          image={logo}
          width={44}
          height={44}
          backupImageUrl={defaultPartnerImage}
          alt={`Logo of ${title}`}
        />
        <Box ml={2} />
        <Box display="flex" flexDirection="column" justifyContent="center">
          <FlexBox>
            <Title>{title}</Title>
            {externalId && (
              <FlexBox ml={0.8}>
                <ThemeTypography variant="BODY_MEDIUM" color="GRAY_80">
                  |
                </ThemeTypography>
                <Box mr={1} />
                <ThemeTypography variant="BODY_MEDIUM" autoOverflow maxWidth={150} color="GRAY_80">
                  {externalId}
                </ThemeTypography>
              </FlexBox>
            )}
          </FlexBox>

          <FlexBox>
            <FlexBox mr={1}>
              <Icon name="tag-filled" color="gray-80" size="small" mr={1} />
              <ThemeTypography variant="BODY_MEDIUM_BOLD" color="GRAY_80">
                Supplier
              </ThemeTypography>
            </FlexBox>
            {isPartnerInvitationsEnabled && (
              <ThemeTypography variant="ITEM_SUBTITLE" color={getCompanyStatusColor(status)}>
                {getReadableCompanyStatus(status)}
              </ThemeTypography>
            )}
          </FlexBox>
        </Box>
      </OpacityContainer>
    </StyledCell>
  );
};

export default PartnerTableTitle;
